<div class="drawer-dependents">
  <div class="drawer-overlay"></div>

  <div class="drawer-content">
    <div class="drawer-header px-2 py-1 d-flex align-items-center justify-content-between">
      <span>Tratamento de Ponto</span>
      <button type="button" class="btn btn-danger btn-icon btn-sm" (click)="closeDrawer()" rippleEffect
        ngbTooltip="Fechar" placement="bottom">
        <i class="feather icon-x text-white"></i>
      </button>

    </div>
    <div class="info-container p-1 shadow-sm rounded mb-3 mx-2 mt-2">
      <div class="d-flex flex-column flex-md-row gap-3 align-items-start align-items-md-center">
        <div class="profile-placeholder profile-placeholder-bg mb-2 mb-md-0 mx-auto mx-md-0 text-center">
          <span *ngIf="!employee?.profileImagePath" class="avatar avatar-square">
            <i data-feather="user" class="font-large-2"></i>
          </span>
          <img *ngIf="employee?.profileImagePath" class="profile-img" [width]="30" [height]="30"
            [src]="employee?.profileImagePath" alt="Foto Colaborador" style="object-fit: cover; border-radius: 8px;" />
        </div>

        <div class="d-flex flex-wrap w-100">
          <div class="col-12 col-sm-6 col-md-4 col-lg-2">
            <div class="info-box">
              <div class="label mb-1">Colaborador(a)</div>
              <div class="value">
                <div class="fw-bold">{{ employee.name }}</div>
                <div class="small text-muted">MAT: {{ employee.registration }}</div>
              </div>
            </div>
            <div class="vertical-divider"></div>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-2">
            <div class="info-box">
              <div class="label mb-1">Cargo</div>
              <div class="value">{{ employee.jobTitleName }}</div>
            </div>
            <div class="vertical-divider"></div>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-2">
            <div class="info-box">
              <div class="label mb-1">Turno</div>
              <div class="value">{{ employee.timeShiftTitle }}</div>
            </div>
            <div class="vertical-divider"></div>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-auto">
            <div class="info-box">
              <div class="label mb-1">Empresa</div>
              <div class="value">{{ employee.companyName }}</div>
            </div>
            <div class="vertical-divider"></div>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-2">
            <div class="info-box">
              <div class="label mb-1">Centro de Custo</div>
              <div class="value">{{ employee.costCenterName }}</div>
            </div>
            <div class="vertical-divider"></div>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-auto" *ngIf="showComptimeBalance">
            <div class="info-box">
              <div class="label mb-1">Saldo BH</div>
              <div class="value">
                <span *ngIf="loadingComptimeBalance" class="spinner-border spinner-border-sm text-primary"></span>
                <ng-container *ngIf="!loadingComptimeBalance">{{ comptimeBalanceLabel }}</ng-container>
              </div>
            </div>
            <div class="vertical-divider"></div>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-auto">
            <div class="info-box">
              <div class="label mb-1">Sincronização</div>
              <button *ngIf="!showComptimeBalance" type="button" (click)="syncOccurrences()" rippleEffect
                class="btn btn-gradient-success mr-1 space-bottom">
                Atualizar Ocorrências
              </button>
              <button *ngIf="showComptimeBalance" type="button" (click)="syncOccurrences()" rippleEffect
                class="btn btn-gradient-success btn-icon gap-3"
                container="body" placement="bottom" tooltipClass="pre-handling-drawer-tooltip"
                ngbTooltip="Atualizar Ocorrências" aria-label="Atualizar Ocorrências">
                <i data-feather="refresh-cw" class="text-white"></i> Atualizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="scrollable-tabs">
      <ul ngbNav #nav="ngbNav" class="nav-tabs mb-3">
        <li [ngbNavItem]="1">
          <a ngbNavLink><span [data-feather]="'user-minus'"></span> Ausências</a>
          <ng-template ngbNavContent>
            <ng-container *ngIf="absenceItens.length > 0 && !uploadingFile && !loading">

              <div class="scrollable-section px-2">

                <div class="scrollable-content">
                  <div *ngFor="let item of absenceItens; let i = index" class="absence-card shadow-sm rounded mb-3 p-2">
                    <div class="d-flex flex-wrap align-items-center gap-4">

                      <div class="col-12 col-md-auto">
                        <div class="label">Data</div>
                        <div class="value">{{ item.day | date : "dd/MM/yyyy" }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horário Previsto</div>
                        <div class="value">
                          {{ formatToHourAndMinutes(item.defaultEntry1) }} |
                          {{ formatToHourAndMinutes(item.defaultDeparture1) }} |
                          {{ formatToHourAndMinutes(item.defaultEntry2) }} |
                          {{ formatToHourAndMinutes(item.defaultDeparture2) }}
                        </div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horário Real</div>
                        <div class="value d-flex align-items-center flex-wrap">
                          <ng-container *ngIf="!hasAnyModifiedTime(item); else modifiedBlock">
                            <ng-container *ngFor="let hour of getRealHours(item)">
                              <span>{{ hour }}</span>&nbsp;|&nbsp;
                            </ng-container>
                          </ng-container>
                          <ng-template #modifiedBlock>
                            <ng-container *ngFor="let hour of getModifiedHours(item)">
                              <span [ngClass]="{ 'text-danger': hour.modified }">
                                {{ hour.value }}
                              </span>&nbsp;|&nbsp;
                            </ng-container>
                          </ng-template>

                          <div *ngIf="showManageRegistrationsInAbsences(item)" class="ms-1">
                            <button type="button" class="btn btn-flat-dark waves-effect"
                              (click)="openManagementRegistrations(item)" placement="bottom"
                              [ngbPopover]="'Gestão de Marcações'" triggers="mouseenter:mouseleave">
                              <i class="feather icon-list"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Ocorrência</div>
                        <div class="value">{{ item.occurrenceTypeName }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horas</div>
                        <div class="value">{{ formatToHourAndMinutes(item.amountTime) }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Justificativa</div>

                        <div *ngIf="isSmallScreen" class="d-flex align-items-center gap-50 flex-wrap">
                          <button class="btn no-boxshadow no-dropdown-toggle-icon ms-0 me-auto"
                            [ngClass]="item.pendingApproval ? 'btn-outline-success' : 'btn-outline-primary'"
                            (click)="openModal(item)">
                            {{ getSelectedBonusReasonTitle(item) || 'Selecionar' }}
                          </button>
                          <button *ngIf="getSelectedBonusReasonDescription(item)" type="button"
                            class="btn btn-icon btn-sm text-primary p-50" container="body" placement="left"
                            tooltipClass="pre-handling-drawer-tooltip" triggers="mouseenter:mouseleave click:blur"
                            [ngbTooltip]="getSelectedBonusReasonDescription(item)"
                            aria-label="Ver descrição da justificativa selecionada">
                            <i data-feather="info" appFeatherIcon></i>
                          </button>
                        </div>

                        <div *ngIf="!isSmallScreen" ngbDropdown class="dropdown custom-link-select-wrapper">
                          <button class="btn no-boxshadow no-dropdown-toggle-icon" ngbDropdownToggle type="button"
                            [ngClass]="item.pendingApproval ? 'btn-outline-success' : 'btn-outline-primary'"
                            (click)="setBonusReasonOptions(item)" container="body" placement="top"
                            tooltipClass="pre-handling-drawer-tooltip"
                            [ngbTooltip]="getSelectedBonusReasonDescription(item)">
                            {{ getSelectedBonusReasonTitle(item) || 'Selecionar' }}
                            <i data-feather="chevron-down" appFeatherIcon></i>
                          </button>

                          <div ngbDropdownMenu class="custom-dropdown-menu">
                            <input type="text" class="form-control mb-2" placeholder="Filtrar justificativas..."
                              [(ngModel)]="filterText" (input)="filterBonusReasons(item)" />
                            <button ngbDropdownItem *ngFor="let option of filteredBonusReasons"
                              (click)="selectBonusReason(option.id, item)" container="body" placement="top"
                              tooltipClass="pre-handling-drawer-tooltip"
                              [ngbTooltip]="bonusReasonDescriptionTooltip(option.description)">
                              {{ option.title }}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-auto" *ngIf="showDocumentInAbsences">
                        <div class="label">Documento</div>
                        <div class="value upload-action-td">
                          <ng-container *ngTemplateOutlet="fileUpload; context: { $implicit: item }"></ng-container>
                        </div>
                      </div>

                      <div *ngIf="item.fileName && showDocumentInAbsences" class="col-12 col-md-auto">
                        <div class="label">Ações do Documento</div>
                        <div class="d-flex justify-content-start">
                          <button *ngIf="canChangeEvidence" type="button" (click)="downloadDocument(item, true)" class="btn btn-icon btn-sm"
                            ngbTooltip="Baixar">
                            <i data-feather="download" size="15"></i>
                          </button>
                          <label *ngIf="canChangeEvidence" class="form-control-label" class="btn btn-icon btn-sm m-0 pointer" ngbTooltip="Trocar">
                            <i data-feather="refresh-cw" size="15"></i>
                            <input type="file" (change)="handleFileInput($event, item)"
                              accept=".pdf,.xlsx,.doc,.docx,.png,.jpg,.jpeg" hidden />
                          </label>
                          <button *ngIf="canViewExcusedEvidences" type="button" (click)="openDocumentPreview(item)"
                            class="btn btn-icon btn-sm" ngbTooltip="Visualizar">
                            <i data-feather="eye" size="15"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="sticky-footer d-flex justify-content-end gap-2 px-2">
                  <button type="button" (click)="paidAbsences()" rippleEffect class="btn btn-gradient-primary me-2">
                    {{ isSameUser ? "Pré-Aprovar" : "Aprovar" }}
                  </button>
                  <button type="button" (click)="closeDrawer()" rippleEffect class="btn btn-outline-secondary">
                    Fechar
                  </button>
                </div>
              </div>
            </ng-container>

            <div *ngIf="loadingOccurrences" class="row justify-content-center text-center">
              <span class="spinner-border spinner-border-sm text-primary"></span>
              <span class="text-primary" style="padding-left: 20px;">Buscando ocorrências...</span>
            </div>

            <div *ngIf="absenceItens.length == 0 && !uploadingFile && !loadingOccurrences"
              class="row justify-content-center text-center w-100">
              <div class="col-auto">
                <h4 class="no-items">Sem registros para exibir.</h4>
              </div>
            </div>

            <div *ngIf="absenceItens.length == 0 && !uploadingFile && !loadingOccurrences"
              class="sticky-footer corner d-flex justify-content-end gap-2 px-2 mt-2">
              <button type="button" (click)="closeDrawer()" rippleEffect class="btn btn-outline-secondary">
                Fechar
              </button>
            </div>

            <div *ngIf="uploadingFile" class="uploading-container">
              <span class="spinner-border spinner-border-sm text-primary"></span>
              <span class="text-primary">Salvando arquivo...</span>
            </div>
          </ng-template>
        </li>

        <ng-template #fileUpload let-occurrence>
          <div class="custom-file-upload" ngbDropdown>
            <div class="upload-label d-flex align-items-center gap-1 flex-wrap" *ngIf="!occurrence.fileName">
              <ng-container *ngIf="documentUploadUiState(occurrence) as docUi">
                <label class="form-control-label d-flex align-items-center gap-1 m-0"
                  [class.cursor-pointer]="!docUi.disabled"
                  [class.upload-send--disabled]="docUi.disabled"
                  container="body" placement="top" tooltipClass="pre-handling-drawer-tooltip"
                  triggers="mouseenter:mouseleave" [disableTooltip]="!docUi.tooltip"
                  [ngbTooltip]="docUi.tooltip">
                  <input [disabled]="docUi.disabled" type="file"
                    (change)="handleFileInput($event, occurrence)" accept=".pdf,.xlsx,.doc,.docx,.png,.jpg,.jpeg"
                    hidden />

                  <i data-feather="upload" class="me-1"
                    [ngClass]="docUi.disabled ? 'text-muted' : 'text-primary'"></i>
                  <span class="file-name" [ngClass]="docUi.disabled ? 'text-muted' : 'text-primary'">Enviar</span>
                </label>
                <small *ngIf="docUi.deadlineHint" class="text-muted w-100 document-upload-hint">{{ docUi.deadlineHint }}</small>
              </ng-container>
            </div>
            <div class="upload-label d-flex align-items-center gap-1" ngbDropdownToggle *ngIf="occurrence.fileName"
              style="cursor: pointer;">
              <span class="file-name">{{ occurrence.fileName }}</span>
              <i data-feather="chevron-down" class="ms-1"></i>
            </div>
            <div *ngIf="occurrence.fileName" ngbDropdownMenu class="dropdown-menu p-0">
              <a *ngIf="canChangeEvidence" type="button" class="dropdown-item" (click)="downloadDocument(occurrence, true)">
                Baixar Evidência
              </a>
              <label *ngIf="canChangeEvidence" class="form-control-label" class="dropdown-item m-0 fix-font-size" style="cursor: pointer;">
                Trocar Evidência
                <input type="file" (change)="handleFileInput($event, occurrence)"
                  accept=".pdf,.xlsx,.doc,.docx,.png,.jpg,.jpeg" hidden />
              </label>
              <a *ngIf="canViewExcusedEvidences" type="button" class="dropdown-item"
                (click)="openDocumentPreview(occurrence)">
                Visualizar Evidência
              </a>
            </div>
          </div>
        </ng-template>

        <ng-template #noOvertime>
          <div class="row justify-content-center text-center w-100">
            <div class="col-auto">
              <h4 class="no-items">Sem registros para exibir.</h4>
            </div>
          </div>
        </ng-template>


        <li [ngbNavItem]="2" *ngIf="canViewOvertimes">
          <a ngbNavLink><span [data-feather]="'clock'"></span> Horas Extras</a>
          <ng-template ngbNavContent>
            <ng-container *ngIf="overtimeItens.length > 0 && !uploadingFile && !loading; else noOvertime">

              <div class="scrollable-section px-2">

                <div class="scrollable-content">
                  <div *ngFor="let item of overtimeItens; let i = index"
                    class="absence-card shadow-sm rounded mb-3 p-2">
                    <div class="d-flex flex-wrap align-items-center gap-4">

                      <div class="col-12 col-md-auto">
                        <div class="label">Data</div>
                        <div class="value">{{ item.day | date: 'dd/MM/yyyy' }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horário Previsto</div>
                        <div class="value">
                          {{ formatToHourAndMinutes(item.defaultEntry1) }} |
                          {{ formatToHourAndMinutes(item.defaultDeparture1) }} |
                          {{ formatToHourAndMinutes(item.defaultEntry2) }} |
                          {{ formatToHourAndMinutes(item.defaultDeparture2) }}
                        </div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horário Real</div>
                        <div class="value">
                          {{ formatToHourAndMinutes(item.realEntry1) }} |
                          {{ formatToHourAndMinutes(item.realDeparture1) }} |
                          {{ formatToHourAndMinutes(item.realEntry2) }} |
                          {{ formatToHourAndMinutes(item.realDeparture2) }} |
                          {{ formatToHourAndMinutes(item.realEntry3) }} |
                          {{ formatToHourAndMinutes(item.realDeparture3) }} |
                          {{ formatToHourAndMinutes(item.realEntry4) }} |
                          {{ formatToHourAndMinutes(item.realDeparture4) }}
                        </div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Ocorrência</div>
                        <div class="value">{{ item.occurrenceTypeName }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horas Extras</div>
                        <div class="value">{{ item.amountTime }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">{{ usesOvertimeJustification ? 'Justificativa' : 'Autorizar?' }}</div>

                        <ng-container *ngIf="usesOvertimeJustification; else overtimeAuthorizeSelect">
                          <div *ngIf="isSmallScreen" class="d-flex align-items-center gap-50 flex-wrap">
                            <button class="btn no-boxshadow no-dropdown-toggle-icon ms-0 me-auto"
                              [ngClass]="item.pendingApproval ? 'btn-outline-success' : 'btn-outline-primary'"
                              (click)="openModal(item)">
                              {{ getSelectedBonusReasonTitle(item) || 'Selecionar' }}
                            </button>
                            <button *ngIf="getSelectedBonusReasonDescription(item)" type="button"
                              class="btn btn-icon btn-sm text-primary p-50" container="body" placement="left"
                              tooltipClass="pre-handling-drawer-tooltip" triggers="mouseenter:mouseleave click:blur"
                              [ngbTooltip]="getSelectedBonusReasonDescription(item)"
                              aria-label="Ver descrição da justificativa selecionada">
                              <i data-feather="info" appFeatherIcon></i>
                            </button>
                          </div>

                          <div *ngIf="!isSmallScreen" ngbDropdown class="dropdown custom-link-select-wrapper">
                            <button class="btn no-boxshadow no-dropdown-toggle-icon" ngbDropdownToggle type="button"
                              (click)="setBonusReasonOptions(item)"
                              [ngClass]="item.pendingApproval ? 'btn-outline-success' : 'btn-outline-primary'"
                              container="body" placement="top" tooltipClass="pre-handling-drawer-tooltip"
                              [ngbTooltip]="getSelectedBonusReasonDescription(item)">
                              {{ getSelectedBonusReasonTitle(item) || 'Selecionar' }}
                              <i data-feather="chevron-down" appFeatherIcon></i>
                            </button>

                            <div ngbDropdownMenu class="custom-dropdown-menu">
                              <input type="text" class="form-control mb-2" placeholder="Filtrar justificativas..."
                                [(ngModel)]="filterText" (input)="filterBonusReasons(item)" />
                              <button ngbDropdownItem *ngFor="let option of filteredBonusReasons"
                                (click)="selectBonusReason(option.id, item)" container="body" placement="top"
                                tooltipClass="pre-handling-drawer-tooltip"
                                [ngbTooltip]="bonusReasonDescriptionTooltip(option.description)">
                                {{ option.title }}
                              </button>
                            </div>
                          </div>
                        </ng-container>

                        <ng-template #overtimeAuthorizeSelect>
                          <div ngbDropdown class="dropdown">
                            <button class="btn btn-outline-primary no-dropdown-toggle-icon no-boxshadow" type="button"
                              ngbDropdownToggle>
                              {{ getSelectedAuthorizeLabel(item.authorized) || 'Selecionar' }}
                              <i data-feather="chevron-down" appFeatherIcon></i>
                            </button>

                            <div ngbDropdownMenu class="p-0">
                              <button class="dropdown-item text-start " *ngFor="let option of authorizeOptions"
                                (click)="selectAuthorizeOption(option.value, item)">
                                {{ option.label }}
                              </button>
                            </div>
                          </div>
                        </ng-template>
                      </div>

                      <div class="col-12 col-md-3" *ngIf="usesOvertimeApprovalReason">
                        <div class="label">Motivo da Decisão</div>
                        <textarea
                          class="form-control"
                          rows="2"
                          maxlength="1000"
                          [(ngModel)]="item.overtimeApprovalReason"
                          [placeholder]="getOvertimeApprovalReasonPlaceholder(item)">
                        </textarea>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="sticky-footer d-flex justify-content-end gap-2 px-2">
                  <button type="button" (click)="authorizeOvertimes()" rippleEffect
                    class="btn btn-gradient-primary me-2">
                    {{ isSameUser ? (usesOvertimeJustification ? 'Pré-Aprovar' : 'Pré-Autorizar') :
                    (usesOvertimeJustification ? 'Aprovar' : 'Autorizar') }}
                  </button>
                  <button type="button" (click)="closeDrawer()" rippleEffect class="btn btn-outline-secondary">
                    Fechar
                  </button>
                </div>
              </div>

            </ng-container>

            <ng-template #noOvertime>
              <div class="row justify-content-center text-center w-100">
                <div class="col-auto">
                  <h4 class="no-items">Sem registros para exibir.</h4>
                </div>
              </div>
              <div class="sticky-footer corner d-flex justify-content-end gap-2 px-2 mt-2">
                <button type="button" (click)="closeDrawer()" rippleEffect class="btn btn-outline-secondary">
                  Fechar
                </button>
              </div>
            </ng-template>
          </ng-template>
        </li>

        <li [ngbNavItem]="3" *ngIf="!disabledPointTimeException && (timeOccurrenceParameters.anyoneCanViewExceptions || canViewExceptions)">
          <a (click)="listPointTimeExceptions()" ngbNavLink>
            <span [data-feather]="'alert-circle'"></span> Exceção de Ponto
          </a>

          <ng-template ngbNavContent>
            <ng-container *ngIf="pointTimeExceptions.length > 0; else noExceptions">
              <div class="scrollable-section px-2">
                <div class="scrollable-content">
                  <div *ngFor="let item of pointTimeExceptions; let i = index"
                    class="absence-card shadow-sm rounded mb-3 p-2">
                    <div class="d-flex flex-wrap align-items-center gap-4">

                      <div class="item-actions">
                        <button (click)="removePointTimeException(item)" type="button" class="btn btn-icon btn-danger">
                          <span [data-feather]="'trash'"></span>
                        </button>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Data</div>
                        <div class="value">{{ item.date | date : "dd/MM/yyyy" }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Tipo</div>
                        <div class="value">{{ getTypeLabel(item.type) }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Entrada 1</div>
                        <div class="value">{{ formatToHourAndMinutes(item.entry1) }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Saída 1</div>
                        <div class="value">{{ formatToHourAndMinutes(item.departure1) }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Entrada 2</div>
                        <div class="value">{{ formatToHourAndMinutes(item.entry2) }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Saída 2</div>
                        <div class="value">{{ formatToHourAndMinutes(item.departure2) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-2 pb-2">
                <div class="d-flex justify-content-start gap-2">
                  <button type="button" (click)="openCreatePointTimeException()" class="btn btn-gradient-primary">
                    Incluir
                  </button>
                  <button type="button" (click)="closeDrawer()" class="btn btn-outline-secondary">
                    Fechar
                  </button>
                </div>
              </div>
            </ng-container>


            <ng-template #noExceptions>
              <div class="item-card mx-2">
                <div class="text-center mb-3">
                  <h4 class="no-items mb-0">Sem exceções de ponto para exibir.</h4>
                </div>
                <div class="d-flex justify-content-start gap-2">
                  <button type="button" (click)="openCreatePointTimeException()" class="btn btn-gradient-primary">
                    Incluir
                  </button>
                  <button type="button" (click)="closeDrawer()" class="btn btn-outline-secondary">
                    Fechar
                  </button>
                </div>
              </div>
            </ng-template>
          </ng-template>
        </li>

        <li [ngbNavItem]="4" *ngIf="canViewExcusedAbsences">
          <a (click)="listExcused()" ngbNavLink>
            <span [data-feather]="'alert-circle'"></span> Ausências Legais
          </a>

          <ng-template ngbNavContent>
            <ng-container *ngIf="excusedAbsences.length > 0; else noExcusedAbsences">
              <div class="item-list px-2">
                <div *ngFor="let item of excusedAbsences" class="w-100 shadow-sm rounded mb-3 p-2">
                  <div class="d-flex flex-wrap align-items-center gap-4">

                    <div class="col-12 col-md-auto">
                      <div class="label">Data inicial</div>
                      <div class="value">{{ item.dateBegin | date: 'dd/MM/yyyy' }}</div>
                    </div>

                    <div class="col-12 col-md-auto">
                      <div class="label">Quantidade dias</div>
                      <div class="value">{{ item.amountDays }}</div>
                    </div>

                    <div class="col-12 col-md-auto">
                      <div class="label">Motivo afastamento</div>
                      <div class="value">{{ getAbsenceReasonLabel(item) }}</div>
                    </div>

                    <div class="col-12 col-md-auto" *ngIf="!isPreAbonoAbsence(item)">
                      <div class="label">CID</div>
                      <div class="value">{{ item.icdClassificationDescription }}</div>
                    </div>

                    <div class="col-12 col-md-auto" *ngIf="!isPreAbonoAbsence(item)">
                      <div class="label">Emitente</div>
                      <div class="value">{{ item.issuerName }}</div>
                    </div>

                    <div class="col-12 col-md-auto">
                      <div class="label">Status</div>
                      <td [innerHTML]="item.statusBadge"></td>
                    </div>

                    <div class="col-12 col-md-auto" *ngIf="isExcusedAbsenceReproved(item)">
                      <div class="label">Motivo da reprovação</div>
                      <div class="value">{{ item.reproveReason || 'Não informado' }}</div>
                    </div>

                    <div class="col-12 col-md-auto">
                      <div class="label">Data Criação</div>
                      <div class="value">{{ item.creationDate | date: 'dd/MM/yyyy HH:mm' }}</div>
                    </div>
                    <div *ngIf="canViewExcusedAbsences && !isSameUser" class="col-12 col-md-auto">
                      <div ngbDropdown class="dropdown custom-link-select-wrapper">
                        <button class="btn no-boxshadow no-dropdown-toggle-icon" ngbDropdownToggle type="button"
                          (click)="openExcusedAbsenceInfo(item)"
                          [ngClass]="getExcusedAbsenceActionClass(item)">
                          {{ getExcusedAbsenceActionLabel(item) }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="canCreateOwnExcusedAbsence && isSameUser" class="px-2 pb-2">
                <div class="d-flex justify-content-start gap-2">
                  <button type="button" (click)="openCreateExcusedAbsence()" class="btn btn-gradient-primary">
                    Incluir Ausência Legal
                  </button>
                </div>
              </div>
            </ng-container>

            <ng-template #noExcusedAbsences>
              <div class="item-card mx-2 text-center">
                <h4 class="no-items">Sem ausências legais para exibir.</h4>
                <div *ngIf="canCreateOwnExcusedAbsence && isSameUser" class="d-flex justify-content-center gap-2 mt-3">
                  <button type="button" (click)="openCreateExcusedAbsence()" class="btn btn-gradient-primary">
                    Incluir Ausência Legal
                  </button>
                </div>
              </div>
            </ng-template>
          </ng-template>
        </li>

        <li ngbNavItem>
          <a (click)="listManagedOccurrences()" ngbNavLink>
            <span [data-feather]="'file-text'"></span> Histórico de Tratamentos
          </a>

          <ng-template ngbNavContent>
            <div class="d-flex justify-content-end px-2 mb-2">
              <div class="btn-group btn-group-sm" role="group" aria-label="Filtro do histórico de tratamentos">
                <button
                  type="button"
                  class="btn"
                  [ngClass]="!useClosedPeriodsHistory ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="setHistoryPeriod(false)">
                  Período Atual
                </button>
                <button
                  type="button"
                  class="btn"
                  [ngClass]="useClosedPeriodsHistory ? 'btn-primary' : 'btn-outline-primary'"
                  (click)="setHistoryPeriod(true)">
                  Períodos Encerrados
                </button>
              </div>
            </div>

            <ng-container *ngIf="managedOccurrences.length > 0; else noHistory">
              <div class="scrollable-section px-2">

                <div class="scrollable-content">
                  <div *ngFor="let item of managedOccurrences; let i = index"
                    class="absence-card shadow-sm rounded mb-3 p-2">
                    <div class="d-flex flex-wrap align-items-center gap-4">
                      <div class="col-12 col-md-auto">
                        <div class="label">Data</div>
                        <div class="value">{{ item.day | date : "dd/MM/yyyy" }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horário Previsto</div>
                        <div class="value">
                          {{ formatToHourAndMinutes(item.defaultEntry1) }} |
                          {{ formatToHourAndMinutes(item.defaultDeparture1) }} |
                          {{ formatToHourAndMinutes(item.defaultEntry2) }} |
                          {{ formatToHourAndMinutes(item.defaultDeparture2) }}
                        </div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horário Real</div>
                        <div class="value d-flex align-items-center flex-wrap">
                          <ng-container *ngIf="!hasAnyModifiedTime(item); else modifiedBlock">
                            <ng-container *ngFor="let hour of getRealHours(item)">
                              <span>{{ hour }}</span> &nbsp;|&nbsp;
                            </ng-container>
                          </ng-container>

                          <ng-template #modifiedBlock>
                            <ng-container *ngFor="let hour of getModifiedHours(item)">
                              <span [ngClass]="{ 'text-danger': hour.modified }">
                                {{ hour.value }}
                              </span> &nbsp;|&nbsp;
                            </ng-container>
                          </ng-template>
                        </div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Ocorrência</div>
                        <div class="value">{{ item.occurrenceTypeName }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Horas</div>
                        <div class="value">{{ item.amountTime }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Justificativa / Autorizado</div>
                        <div class="value">
                          <ng-container *ngIf="item.subType == 'ABSENCE'">
                            {{ getSelectedBonusReasonTitle(item) }}
                          </ng-container>
                          <ng-container *ngIf="item.subType == 'OVERTIME'">
                            {{ getOvertimeHistoryLabel(item) }}
                          </ng-container>
                        </div>
                      </div>

                      <div class="col-12 col-md-3" *ngIf="item.subType == 'OVERTIME' && usesOvertimeApprovalReason">
                        <div class="label">Motivo da Decisão</div>
                        <div class="value">{{ getOvertimeApprovalReasonLabel(item) }}</div>
                      </div>

                      <div class="col-12 col-md-auto">
                        <div class="label">Data e Hora do Tratamento</div>
                        <div class="value">{{ item.treatmentDate | date : "dd/MM/yyyy - HH:mm" }}</div>
                      </div>

                      <div class="col-12 col-md-auto" *ngIf="showDocumentInHistory">
                        <div class="label">Documento</div>
                        <div class="value">
                          <button [disabled]="!item.fileKey" type="button" class="btn btn-flat-dark waves-effect"
                            (click)="downloadDocument(item, false)" placement="bottom"
                            [ngbPopover]="'Download do Documento'" triggers="mouseenter:mouseleave">
                            <i class="feather custom-icon-cloud-download" [ngClass]="{
                      'text-secondary': !item.fileKey,
                      'text-primary': item.fileKey
                    }">
                            </i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </ng-container>

            <ng-template #noHistory>
              <div *ngIf="loadingManagedOccurrences" class="row justify-content-center text-center w-100">
                <span class="spinner-border spinner-border-sm text-primary"></span>
                <span class="text-primary" style="padding-left: 20px;">Buscando histórico...</span>
              </div>

              <div *ngIf="!loadingManagedOccurrences" class="row justify-content-center text-center w-100">
                <div class="col-auto">
                  <h4 class="no-items">
                    Sem histórico para exibir no {{ useClosedPeriodsHistory ? 'período encerrado' : 'período atual' }}.
                  </h4>
                </div>
              </div>
            </ng-template>
          </ng-template>
        </li>

      </ul>
    </div>
    <div [ngbNavOutlet]="nav" class="mt-1"></div>
  </div>
</div>